import { Injectable } from '@angular/core';
import { Idle, WindowInterruptSource } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthService } from './auth.service';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class TimeoutService {
  // Idleness properties -------
  public idleState = 'Not started.';
  public showAlert: boolean = false;
  timedOut = false;
  idleTime: number;
  lastPing?: Date = null;
  countdown?: number = null;

  // --------------------
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private authService: AuthService,
    // private cd: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {
    this.handleIdleness()
  }

  public openSnackBar(message: string) {
    this.snackBar.open(message, '', { duration: 2000 });
  }

  handleIdleness() {
    this.idleTime = window['config'].idleTime;
    this.idle.setIdle(window['config'].idleTime);
    this.idle.setTimeout(window['config'].idleTime);
    const x = 'keydown DOMMouseScroll mousemove mousewheel mousedown touchstart touchmove scroll';
    this.idle.setInterrupts([new WindowInterruptSource(x)]);
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      console.log(this.idleState);
      this.countdown = null;
      this.showAlert = false;
      this.reset();
      // this.cd.detectChanges();
    });
    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.showAlert = true;
      this.timedOut = true;
      if (this.authService.isLoggedIn())
        this.authService.loggeOut();
      this.reset();
    });

    this.idle.onTimeoutWarning.subscribe((seconds) => {
      this.countdown = seconds;
      if (this.authService.isLoggedIn()) {
        this.showAlert = true;
        if (seconds <= 20) { this.openSnackBar(`Your session will end in ${seconds}!`); }
      }
    });

    this.idle.onIdleStart.subscribe(() => {
      this.showAlert = true;
      this.idleState = 'You\'ve gone idle!'
      console.log(this.idleState);
    });
    this.keepalive.interval(15);
    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.countdown = null;
    this.lastPing = null;
  }


}
